import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Phone Number Input field component.
 * Some of the code is sourced from
 * https://www.npmjs.com/package/react-headless-phone-input but adapted for the
 * application's needs.
 */
import { forwardRef, useControllableState } from '@chakra-ui/react';
import { MOBILE_EXAMPLES } from './resources/examples';
import { IntlPhoneNumberInput } from './IntlPhoneNumberInput';
import { PhoneNumberInputProvider, } from './PhoneNumberInputContext';
import { SingleCountryPhoneNumberInput } from './SingleCountryPhoneNumberInput';
export const PhoneNumberInput = forwardRef(({ defaultCountry = 'SG', allowInternational = true, onChange: onChangeProp, onBlur, value: valueProp, defaultValue, examples = MOBILE_EXAMPLES, examplePlaceholder = 'polite', ...props }, ref) => {
    const [value, onChange] = useControllableState({
        value: valueProp,
        defaultValue,
        onChange: onChangeProp,
    });
    const providerProps = {
        defaultCountry,
        allowInternational,
        onChange,
        onBlur,
        defaultValue: value,
        examples,
        examplePlaceholder,
        placeholder: props.placeholder,
    };
    return (_jsx(PhoneNumberInputProvider, { ...providerProps, children: allowInternational ? (_jsx(IntlPhoneNumberInput, { ...props, ref: ref })) : (_jsx(SingleCountryPhoneNumberInput, { ...props, ref: ref })) }));
});
PhoneNumberInput.displayName = 'PhoneNumberInput';
